<div class="engagement-panel">
  @if (openEngRemovalRequestPopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin">
      <div #popupContent  class="add-client-container">
        @if (!(modulesExist || usersExist)) {
          <div>
            <div class="popup-header">
              <div class="popup-header" >
                <div class="popup-title"><span style="color:red">Warning:</span> Client Engagement Deletion</div>
                <button class="close-btn" (click)="close()">&#x2715;</button>
              </div>
            </div>
            <div>
              <div class="engagement-details-section">
                <form class="k-form k-form-md" [formGroup]="engCancellationForm">
                  <div>
                    <div>
                      @if (!showFinalConfirmation) {
                        <div>
                          You are about to delete a Client Engagement. This action cannot be undone and may have the following consequences:
                        </div>
                      }
                      @if (showFinalConfirmation) {
                        <div>
                          Are you sure?
                        </div>
                      }
                      <br/>
                      <br/>
                      - Loss of critical compliance data associated with this engagement. <br/>
                      - Potential risk of non-compliance with regulatory requirements. <br/>
                      - Interruption of ongoing risk assessment and management processes. <br/>
                      <br/>
                    </div>
                    Please confirm that you understand the implications of this action and wish to proceed or select @if (!showFinalConfirmation) {
                    <span>'Cancel'</span>
                    }@if (showFinalConfirmation) {
                    <span>'I'VE CHANGED MY MIND'</span>
                    } to maintain the current engagement.
                  </div>
                  <br/>
                  <br/>
                  @if (!showFinalConfirmation) {
                    <div>
                      <p>Type 'Delete Client Engagement' Below to confirm</p>
                      <input kendoTextBox type="text" pInputText formControlName="confirmDeleteEngText" (input)="onInputChange()" style="width:60%"/>
                    </div>
                  }
                </form>
              </div>
              @if (!showFinalConfirmation) {
                <div class="form-buttons" style="border-top: 1px solid rgba(33, 37, 41, 0.2); padding-top:7px;">
                  <button kendoButton type="button" style="width: 100%; margin-right: 10px;" [disabled]="!isConfirmedTextEng" [ngClass]="{'removal-button': isConfirmedTextEng}" (click)="showFinalConfirmation = true">YES, DELETE</button>
                  <button kendoButton type="button" (click)="cancelEngRemovalRequest()" style="width: 100%;">CANCEL</button>
                </div>
              }
              @if (showFinalConfirmation) {
                <div class="form-buttons" style="border-top: 1px solid rgba(33, 37, 41, 0.2); padding-top:7px;">
                  <button  kendoButton type="button" (click)="processEngRemovalRequest()" class="removal-button">YES I'M POSITIVE</button>
                  <button kendoButton type="button" (click)="cancelEngRemovalRequest()" style="width: 100%;">I'VE CHANGED MY MIND</button>
                </div>
              }
            </div>
          </div>
        }
        @if ((modulesExist || usersExist)) {
          <div>
            <div class="popup-header">
              <div class="popup-title"><span style="color: red">Error:</span> Client Engagement Deletion</div>
              <button class="close-btn" (click)="close()">&#x2715;</button>
            </div>
            <div>
              <div class="engagement-details-section">
                <form class="k-form k-form-md" >
                  <div>
                    <div>
                      An engagement can only be deleted if there are no modules, users or data associated with it.
                      <br/>
                      <br/>
                      @if (modulesExist) {
                        <div>
                          Associated list of modules:
                          <ul>
                            @for (module of engRemovalData.modules; track module) {
                              <li>{{ module.name }}</li>
                            }
                          </ul>
                        </div>
                      }
                      <br/>
                      @if (usersExist) {
                        <div>
                          Associated list of users:
                          <ul>
                            @for (user of engRemovalData.users; track user) {
                              <li>{{ user.name }}</li>
                            }
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                </form>
              </div>
              <div class="form-buttons">
                <button kendoButton type="button" (click)="cancelEngRemovalRequest()" class="w-100" style="background-color: #00338d;color: #fff">OK</button>
              </div>
            </div>
          </div>
        }
      </div>
    </kendo-popup>
  }
</div>


@if (openEngRemovalRequestPopup) {
  <div class="k-popup-backdrop"></div>
}
